import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// 多语言
import I18n from "@/languages/index";
// 轮播图
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css';
// Element
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 视频

import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import {  createPinia } from 'pinia'
import piniaPluginPersistedstate  from 'pinia-plugin-persistedstate'

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate)


createApp(App).use(pinia).use(router).use(VueAwesomeSwiper).use(I18n).use(ElementPlus).use(VideoPlayer).mount('#app')
